(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ka-carousel-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ka-item-carousel')) {
 customElements.define('ka-item-carousel', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const track = this.querySelector('.ka-carousel-track');
   const previous = this.querySelector('[data-carousel-prev]');
   const next = this.querySelector('[data-carousel-next]');
   if (!track || !previous || !next) return;
   const update = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
   };
   const move = direction => {
    const card = Array.from(track.children).find(child => !child.hidden);
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    track.scrollBy({left:direction * ((card ? card.getBoundingClientRect().width : track.clientWidth) + gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   };
   previous.addEventListener('click', () => move(-1));
   next.addEventListener('click', () => move(1));
   track.addEventListener('scroll',update,{passive:true});
   const resize = new ResizeObserver(update);
   resize.observe(track);
   const mutation = new MutationObserver(() => {track.scrollLeft = 0;update();});
   mutation.observe(track,{subtree:true,attributes:true,attributeFilter:['hidden']});
   this.cleanup = () => {resize.disconnect();mutation.disconnect();};
   update();
  }
  disconnectedCallback() {if(this.cleanup)this.cleanup();this.initialized=false;}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ka-weekender-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ka-weekender-gallery')) {
  customElements.define('ka-weekender-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-weekender-view]');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.ka-weekender-image');
        if (!image) return;
        image.srcset = button.dataset.srcset;
        image.src = button.dataset.src;
        image.alt = button.dataset.alt;
        image.width = Number(button.dataset.width);
        image.height = Number(button.dataset.height);
        this.querySelector('[data-weekender-title]').textContent = button.dataset.title;
        const description = this.querySelector('[data-weekender-description]');
        description.textContent = button.dataset.description;
        description.hidden = !button.dataset.description;
        this.querySelectorAll('[data-weekender-zoom]').forEach((link) => {
          link.href = button.dataset.zoom;
        });
        this.querySelectorAll('[data-weekender-view]').forEach((view) => {
          view.setAttribute('aria-pressed', String(view === button));
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
